class ErrorMessageUtil {
  static transform(error) {
    return error.messages
      ? `<ul> ${error.messages.map((m) => `<li>${m.message}</li>`).join('')} </ul>`
      : error.message;
  }
}

export default ErrorMessageUtil;
